var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _circle4, _circle5, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampingThumbnailContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M25.3749 64.2665C37.1043 63.0447 41.4769 67.7706 42.1971 70.2863C47.1553 80.858 47.7197 92.8508 46.453 99.3404C36.4608 99.7595 40.493 100.665 32.501 101C30.5027 101.084 29.4076 92.0743 19.3656 92.5261C12.8157 92.8208 7.83545 89.664 6.29117 84.6323C4.74688 79.6006 10.7132 65.7938 25.3749 64.2665Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M59.501 78C48.701 77.2 35.3343 97.5 32.501 101H93.001C89.801 95.8 75.1676 76.3333 71.501 76.5C74.301 68.5 82.1676 63.1667 86.001 61L48.001 67C56.801 69.8 60.1676 74.8333 59.501 78Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M58 101C58.0336 93.5425 59.3798 86.0171 64.6891 84.5001C71.0094 82.6943 78.2356 92.3017 82.7689 101H58Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M42.001 26.0001C45.601 26.4001 48.1676 28.8334 49.001 30.0001L45.501 36.0001C43.001 36.6667 38.001 37.1001 38.001 33.5001C38.001 29.9001 36.6676 27.6667 36.001 27.0001C36.501 26.5001 38.401 25.6001 42.001 26.0001Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M83.001 17C79.001 17.8 76.6676 22 76.001 24L79.501 27.5C80.6676 26.8333 83.201 24.9 84.001 22.5C84.801 20.1 83.6676 17.8333 83.001 17Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M48.3303 27.7714C41.6668 32.2485 40.001 45.9175 40.001 52.1923C49.9962 58.2976 74.7066 53.0403 86.8536 49.6485C86.8536 46.935 88.4153 42.5257 87.8947 36.4205C87.542 32.284 81.3007 25.9059 78.5242 23.1924C72.7978 20.6486 56.6597 22.1749 48.3303 27.7714Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M50.001 30.4999C44.401 34.8999 42.3343 47.9999 42.001 53.9999C54.801 55.9999 63.001 51.4999 65.501 48.9999C61.501 31.7999 53.501 29.4999 50.001 30.4999Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M77.001 35.5C77.001 39.1 81.3343 44.3333 83.501 46.5C85.501 45.5 90.501 44.5 88.501 37.5C86.901 31.9 81.8343 26.5 79.501 24.5C77.501 25.5 77.001 31 77.001 35.5Z",
    fill: "white",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M52.5007 51C54.5007 51 61.0007 50 64.0007 49.5C67.1674 49.1667 74.2007 48.2 77.0007 47C80.5007 45.5 89.0007 43.5 91.0007 45C93.0007 46.5 94.0007 48 94.0007 51.5C94.0007 55 90.0007 59 86.5007 61C83.0007 63 79.5007 63 78.0007 63C76.8007 63 75.1674 64.3333 74.5007 65C66.5007 70 65.0007 69.5 53.5007 68.5C42.0007 67.5 38.0007 61.5 37.0007 58C36.0007 54.5 37.5007 51.5 40.0007 50.5C42.5007 49.5 50.0007 51 52.5007 51Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M76.7545 65.8637C80.0794 63.2455 80.2179 57.8637 79.8716 55.5C78.6247 56.8091 72.7717 57.5 70.001 57.6818C70.001 58.7728 72.5985 69.1365 76.7545 65.8637Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M62.5008 50C62.9008 48 66.1674 47 67.5007 47C71.3341 46.5 78.9043 44.8999 80.5043 44.4999C82.5043 43.9999 81.5189 58.8314 76.5045 59.5C69.0046 60.5 62.0008 52.5 62.5008 50Z",
    fill: "white",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M76.501 51.0503C77.301 50.6503 79.1676 46.8836 80.001 45.0503C74.401 43.4503 69.001 45.717 67.001 47.0503C69.6676 48.3836 75.301 51.0503 76.501 51.0503Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5621 42.6188C59.3621 39.4188 56.8395 39.2998 54.0621 39.6188C50.1823 40.0645 47.5621 43.1188 48.0621 47.6188C48.4621 51.2188 53.3027 51.9485 56.5621 50.6188C59.7962 49.2994 61.7621 45.8188 60.5621 42.6188Z",
    fill: "white",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.731 37.8333C88.7952 35.1666 85.2056 34.5 83.5013 35C82.0012 39.5 84.8566 43.7592 87.0013 44.5C89.0013 44.5 90.6669 40.5 89.731 37.8333Z",
    fill: "white",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.501,
    cy: 46,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.501,
    cy: 39,
    r: 2.5,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.001,
    cy: 45.5,
    r: 4,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.001,
    cy: 44.5,
    r: 1,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.501,
    cy: 38,
    r: 0.5,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.001 62V67",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampingThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CampingThumbnail-contrast.356ae3673e5f8e7a541617808d4700a9.svg";